import React from 'react';
import moment from 'moment';
import { CalendlyEventInfoProps } from '../models/calendarModels';

const CalendlyEventInfo: React.FC<CalendlyEventInfoProps> = ({
  matchedEvents,
}) => {
  if (matchedEvents?.length === 0) {
    return (
      <div className="d-flex-center">
        <span className="date-pricing pb-0_375rem">No meetings booked</span>
      </div>
    );
  }

  const name =
    matchedEvents[0]?.participants?.invitees?.[0]?.name ?? 'No meetings booked';
  const count = matchedEvents.reduce((total, event) => {
    const inviteesCount = event.participants?.invitees?.length || 0;
    return total + inviteesCount;
  }, 0);

  return (
    <div className="d-flex-center">
      <span className="date-pricing  pb-0_375rem">{name}</span>
      <span className="date-pricing">
        {count - 1 <= 0 ? '' : `+${count - 1}`}
      </span>
    </div>
  );
};

export default CalendlyEventInfo;
